import { Selector } from "./Selector";
import { PersonaExpanded } from "winslow-core";

type PersonaSelectorProps = {
  onChange: (value: string) => void;
  includeNoFilter?: boolean;
  placeholder?: string;
  openOnTop?: boolean;
  personas: PersonaExpanded[];
  disabled?: boolean;
  value?: string | null;
};

export const PersonaSelector = ({
  onChange,
  includeNoFilter = true,
  placeholder = "Select persona...",
  openOnTop = true,
  personas,
  disabled = false,
  value,
}: PersonaSelectorProps) => {
  // Convert personas to option format
  const options = personas.map((persona) => ({
    value: persona.id,
    label: persona.name,
    imageUrl: undefined,
  }));

  if (includeNoFilter) {
    options.unshift({
      value: "NO_PERSONA",
      label: "(No Persona)",
      imageUrl: undefined,
    });
    options.unshift({
      value: "",
      label: "(all resources)",
      imageUrl: undefined,
    });
  }

  return (
    <Selector
      openOnTop={openOnTop}
      placeholder={placeholder}
      options={options}
      onChange={onChange}
      roundIcons={false}
      disabled={disabled}
      value={value || ""}
    />
  );
};
